import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadContractIndexedRentListStatus: 'idle',
    loadContractIndexedRentListError: undefined as any,
    loadContractIndexedRentListLastArgs: undefined as any,
    loadContractIndexedRentStatus: 'idle',
    loadContractIndexedRentError: undefined as any,
    saveContractIndexedRentStatus: 'idle',
    saveContractIndexedRentError: undefined as any,
    deleteContractIndexedRentStatus: 'idle',
    deleteContractIndexedRentError: undefined as any,

    flidxList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadContractIndexedRentList = createAsyncThunk('flidxSlice/loadContractIndexedRentList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().flidxSlice.loadContractIndexedRentListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/flidx/?action=gte&min_objnr=${parentModel.OBJNR}&max_objnr=${parentModel.OBJNR}&min_pernr=${parentModel.PNO}&max_pernr=${parentModel.PNO}&min_flnr=${parentModel.FLSTMNR}&max_flnr=${parentModel.FLSTMNR}&min_BELBEGINN=${parentModel.BEGIN}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadContractIndexedRentListStatus } = getState().flidxSlice
        return loadContractIndexedRentListStatus !== 'pending'
    }
})

export const loadContractIndexedRent = createAsyncThunk('flidxSlice/loadContractIndexedRent', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/flidx/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadContractIndexedRentStatus } = getState().flidxSlice
        return loadContractIndexedRentStatus !== 'pending'
    }
})

export const saveContractIndexedRent = createAsyncThunk('flidxSlice/saveContractIndexedRent', async ({ flidx }: any, { rejectWithValue }: any) => {
    let promises = []
    if (flidx?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/flidx/${ flidx?.HDR_ID }/`,
            prepareData(flidx),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/flidx/`,
            prepareData(flidx),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveContractIndexedRentStatus } = getState().flidxSlice
        return saveContractIndexedRentStatus !== 'pending'
    }
})

export const deleteContractIndexedRent = createAsyncThunk('flidxSlice/deleteContractIndexedRent', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/flidx/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteContractIndexedRentStatus } = getState().flidxSlice
        return deleteContractIndexedRentStatus !== 'pending'
    }
})

const FlidxSlice = createSlice({
    name: 'flidxSlice',
    initialState,
    reducers: {
        resetloadContractIndexedRentListError: (state) => {
            state.loadContractIndexedRentListError = undefined
        },
        resetloadContractIndexedRent: (state) => {
            state.formItem = undefined
            state.loadContractIndexedRentError = undefined
        },
        resetloadContractIndexedRentError: (state) => {
            state.loadContractIndexedRentError = undefined
        },
        resetsaveContractIndexedRent: (state) => {
            state.formItem = undefined
            state.saveContractIndexedRentError = undefined
        },
        resetsaveContractIndexedRentError: (state) => {
            state.saveContractIndexedRentError = undefined
        },
        resetdeleteContractIndexedRentError: (state) => {
            state.deleteContractIndexedRentError = undefined
        },
        removeFromFlidxListById: (state, action) => {
            state.flidxList = state.flidxList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromFlidxListByIds: (state, action) => {
            state.flidxList = state.flidxList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.flidxList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadContractIndexedRentListStatus = 'preloaded'
            state.loadContractIndexedRentListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.flidxList = []
            state.loadContractIndexedRentListStatus = 'idle'
            state.loadContractIndexedRentListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadContractIndexedRentList.pending, (state) => {
            state.loadContractIndexedRentListStatus = 'pending'
            state.loadContractIndexedRentListError = undefined
        })
        builder.addCase(loadContractIndexedRentList.fulfilled, (state, action) => {
            state.loadContractIndexedRentListStatus = 'idle'

            if (!action.payload) { return }

            state.loadContractIndexedRentListLastArgs = action.payload.args

            {
                state.flidxList = action.payload.data

            }
        })
        builder.addCase(loadContractIndexedRentList.rejected, (state, action) => {
            state.loadContractIndexedRentListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadContractIndexedRentListError = action.error.message
            } else {
                state.loadContractIndexedRentListError = action.payload
            }
        })

        builder.addCase(loadContractIndexedRent.pending, (state) => {
            state.loadContractIndexedRentStatus = 'pending'
            state.loadContractIndexedRentError = undefined
        })
        builder.addCase(loadContractIndexedRent.fulfilled, (state, action) => {
            state.loadContractIndexedRentStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flidxList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flidxList.push(newItem) }
                else { state.flidxList[i] = { ...state.flidxList[i], ...newItem } }
            }
        })
        builder.addCase(loadContractIndexedRent.rejected, (state, action) => {
            state.loadContractIndexedRentStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadContractIndexedRentError = action.error.message
            } else {
                state.loadContractIndexedRentError = action.payload
            }
        })

        builder.addCase(saveContractIndexedRent.pending, (state) => {
            state.saveContractIndexedRentStatus = 'pending'
            state.saveContractIndexedRentError = undefined
        })
        builder.addCase(saveContractIndexedRent.fulfilled, (state, action) => {
            state.saveContractIndexedRentStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flidxList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flidxList.push(newItem) }
                else { state.flidxList[i] = { ...state.flidxList[i], ...newItem } }
            }
        })
        builder.addCase(saveContractIndexedRent.rejected, (state, action) => {
            state.saveContractIndexedRentStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveContractIndexedRentError = action.error.message
            } else {
                state.saveContractIndexedRentError = action.payload
            }
        })

        builder.addCase(deleteContractIndexedRent.pending, (state) => {
            state.deleteContractIndexedRentStatus = 'pending'
            state.deleteContractIndexedRentError = undefined
        })
        builder.addCase(deleteContractIndexedRent.fulfilled, (state, action) => {
            state.deleteContractIndexedRentStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.flidxList = state.flidxList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.flidxList = state.flidxList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteContractIndexedRent.rejected, (state, action) => {
            state.deleteContractIndexedRentStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteContractIndexedRentError = action.error.message
            } else {
                state.deleteContractIndexedRentError = action.payload
            }
        })

    }
})

export const {
    resetloadContractIndexedRentListError,
    resetloadContractIndexedRent,
    resetloadContractIndexedRentError,
    resetsaveContractIndexedRent,
    resetsaveContractIndexedRentError,
    resetdeleteContractIndexedRentError,
    removeFromFlidxListById,
    removeFromFlidxListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = FlidxSlice.actions
export default FlidxSlice.reducer
